import { render, staticRenderFns } from "./DialogDetailShipping.vue?vue&type=template&id=537807df&lang=html"
import script from "./DialogDetailShipping.vue?vue&type=script&lang=js"
export * from "./DialogDetailShipping.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports